// extracted by mini-css-extract-plugin
export default {"item":"LlPhw","withPlaceholder":"SNn_1","double":"h8_xq","bannerRow":"SIO56","survey":"YxgmK","row":"lcSMD","isInSpotlight":"DiaNB"};